export default "__VITE_ASSET__a1c50e33__"